module.exports = __webpack_public_path__ + "media/assets/img/products/studio_europe-unavailable-dec285b412bf8da3f047b03fa5a7c734.svg";